export const getPostRoute = (lang: string, slug: string) =>
  `/blog/${lang}/${slug}/`;
